import * as React from 'react'
import moment from 'moment'
import Datepicker from 'react-datepicker'

interface IProps {
  label: string
  selectedValue?: moment.Moment | null
  onChange: (date: moment.Moment | null) => void
  containerClassName?: string
  pickerClassName?: string
  maxDate?: moment.Moment
  minDate?: moment.Moment
}

export const DatePicker: React.FC<IProps> = ({
  label,
  selectedValue = null,
  onChange,
  containerClassName,
  pickerClassName,
  maxDate,
  minDate,
}: IProps) => (
  <div className={containerClassName}>
    <label>{label}</label>
    <Datepicker
      className={`form-control ${pickerClassName}`}
      peekNextMonth
      maxDate={maxDate}
      minDate={minDate}
      showMonthDropdown
      showYearDropdown
      dropdownMode='select'
      selected={selectedValue}
      onChange={onChange}
    />
  </div>
)
